/**
 * Formate un montant en centimes en format monétaire (euro).
 *
 * @param {number} priceInCentimes - Le montant en centimes. 4020
 * @returns {string} Le montant formaté en euros. 40.20 €
 */
export function formatEuro(priceInCentimes) {
  const priceInEuros = priceInCentimes / 100;
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(priceInEuros);
}
